import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { FreespinStatusbarView } from '../../view/freespin/FreespinStatusbarView';
import AnimateEntrance from '../helper/animate';
import { formatDate } from './helper/FormatDate';

class FreespinPromptController {
	constructor(vc, config) {
		this.enabled = true;
		this.vc = vc;
		this.configs = config;
		this.item = vc[this.configs.holder];
		this.play = this.item.FREE_SPIN_PLAY_NOW;
		this.later = this.item.FREE_SPIN_PLAY_LATER;
		this.play.handler = this.handlePlay.bind(this);
		this.later.handler = this.handleLater.bind(this);

		this.init();
		AnimateEntrance(this.vc);
	}

	init() {
		this.item.FREE_SPIN_PRIZE.text = GameConfigs.freeSpin.count + ' FREE SPINS';
		this.item.FREE_SPIN_TIME_FRAME_WRAPPER.FREE_SPIN_TIME.text = formatDate(
			GameConfigs.freeSpin.end_date
		);
	}

	handleLater() {
		HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
			freespin: {
				bet_level: 0,
				count: 0,
				status: '',
				isFinished: false,
				totalWin: 0,
				hasBonus: false,
				show: false
			}
		});
		GameConfigs.freeSpinLocal = {
			bet_level: 0,
			count: 0,
			status: '',
			isFinished: false,
			totalWin: 0,
			hasBonus: false,
			show: false
		};
		if (GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]) {
			GameConfigs.uiComponent.removeView(
				GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
			);
			// GameConfigs.uiComponent.removeChild(COMPONENTS.FREESPIN_STATUS_BAR)
		}
		let disabled = {
			bonus_widget: false,
			double_widget: false,
			info: false,
			settings: false,
			spin: false,
			auto: false,
			fast: false,
			quest_widget: false,
			bet_amount: false
		};

		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
		GameConfigs.disabled = disabled;
		GameConfigs.isFreeSpin = false;
		GameConfigs.freeSpin = null;
	}

	handlePlay() {
		if (this.enabled) {
			this.enabled = false;
			GameConfigs.uiComponent.addView(FreespinStatusbarView);
			HELPERS.dispatchCustomEvent(EVENTS.BET_UPDATE, {
				betAmount: GameConfigs.config.bet_steps[GameConfigs.freeSpin.bet_level]
			});
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
				freespin: {
					...GameConfigs.freeSpinLocal,
					show: false,
					started: true
				}
			});
			GameConfigs.freeSpinLocal = {
				...GameConfigs.freeSpinLocal,
				show: false,
				started: true
			};
			let disabled = {
				...GameConfigs.disabled,
				auto: false,
				spin: false
			};
			HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
			if (GameConfigs.doubleChance) {
				HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
					doubleChance: false
				});
			}
		}
	}
}
export default FreespinPromptController;
